import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";
import React, { useEffect, useState } from "react";
import PaginationComponent from "shared/components/pagination";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useWindowSize from "shared/customHooks/windowSize";
import {
  headers_enums,
  new_books,
  final_approval_book,
  revised_partners,
  internal_review,
  external_review,
} from "./constants";
import { useNavigate, useParams } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import NewBooks from "./newBooks";
import InternalReview from "./internalReview";
import ExternalReview from "./externalReview";
import FinalApproval from "./finalApproval";
import ReviewSubmitted from "./reviewSubmitted";

function AdminPendingTasks() {
  const params = useParams();
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [headers, setHeaders] = useState<any>(new_books);
  const [activePage, setActivePage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");

  const tabs = [
    {
      value: 0,
      label: "New Books",
      counter: 5,
      tabs_enum: "new_books",
    },
    {
      value: 1,
      label: "Books for Final Approval",
      counter: 8,
      tabs_enum: "final_approval",
    },
    {
      value: 2,
      label: "Revised Books from Partner",
      counter: 6,
      tabs_enum: "revised_books",
    },
    {
      value: 3,
      label: "Books in internal review",
      counter: 24,
      tabs_enum: "internal_review",
    },
    {
      value: 4,
      label: "External revision",
      counter: 11,
      tabs_enum: "external_revision",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);

    let filteredTab: any = tabs.findIndex((item) => item?.value === newValue);

    if (filteredTab > -1) {
      navigate(
        routeConstant.pendingTasks.path
          .replace(":keyword", "hod")
          .replace(":task", tabs[filteredTab]?.tabs_enum)
      );
    }

    if (newValue === headers_enums.new_books) {
      setHeaders(new_books);
    } else if (newValue === headers_enums.final_approval_book) {
      setHeaders(final_approval_book);
    } else if (newValue === headers_enums.internal_review) {
      setHeaders(internal_review);
    } else if (newValue === headers_enums.revised_partners) {
      setHeaders(revised_partners);
    } else if (newValue === headers_enums.external_review) {
      setHeaders(external_review);
    }
  };

  useEffect(() => {
    let filteredTab: any = tabs.findIndex(
      (item) => item?.tabs_enum === params?.task
    );

    if (filteredTab > -1) {
      handleChange("", tabs[filteredTab]?.value);
    }

    // eslint-disable-next-line
  }, [params?.task]);

  return (
    <div>
      <div className={styles.topLevelContainer}>
        <div className={styles.headingContainer}>
          <label className={styles.heading}>Pending Task of HOD</label>
          <label className={styles.subHeading}>
            Table with pending task tabs, list and actions to perform.
          </label>
        </div>
        <div className={styles.rangePicker}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            doubleLabel={true}
          />
        </div>
      </div>

      <div className={styles.mainContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                      <label className={styles.tabCounter}>
                        {item?.counter}
                      </label>
                    </div>
                  }
                />
              );
            })}
          </Tabs>
        </Box>
        <Box className={styles.toptableContainer}>
          <div className={styles.headingContainer}>
            {activeTab === headers_enums.new_books ? (
              <>
                <label className={styles.tableHeading}>
                  New Books - Pending for initial review
                </label>
              </>
            ) : activeTab === headers_enums.final_approval_book ? (
              <>
                <label className={styles.tableHeading}>
                  Books for Final Approval - Submitted from Reviewers
                </label>
              </>
            ) : activeTab === headers_enums.revised_partners ? (
              <>
                <label className={styles.tableHeading}>
                  Books submitted after revision from partners
                </label>
              </>
            ) : activeTab === headers_enums.internal_review ? (
              <>
                <label className={styles.tableHeading}>
                  Books in internal review - sent to reviewers
                </label>
              </>
            ) : activeTab === headers_enums.external_review ? (
              <>
                <label className={styles.tableHeading}>
                  Books in external revision - sent to partners
                </label>
              </>
            ) : (
              " "
            )}
          </div>
          <div className={styles.gridContainer}>
            <Icons.SearchIcon className={styles.searchIcon} />
            <input
              placeholder="Search"
              className={styles.input}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Box>

        <TableContainer
          component={Paper}
          className={styles.tableContainer}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          id="table-view-dashboard"
        >
          <Table aria-label="simple table">
            <TableHead className={styles.tableHead}>
              <TableRow>
                {headers?.map((item: any) => {
                  return (
                    <>
                      <TableCell>{item}</TableCell>
                    </>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {activeTab === headers_enums.new_books ? (
                <NewBooks />
              ) : activeTab === headers_enums.internal_review ? (
                <InternalReview />
              ) : activeTab === headers_enums.external_review ? (
                <ExternalReview />
              ) : activeTab === headers_enums.final_approval_book ? (
                <FinalApproval />
              ) : headers_enums.revised_partners ? (
                <ReviewSubmitted />
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <PaginationComponent
          totalPages={"1"}
          activePage={activePage}
          setActivePage={setActivePage}
        />
      </div>
    </div>
  );
}

export default AdminPendingTasks;
